import { combineTokens } from '@utils/css';

combineTokens("--audio", {
  backgroundColor: "rgba(0,0,0,0)"
});
const wrapperCls = "_vcw1pzvp69";

export { wrapperCls };
import "./audio-component.style.linaria.module.css";
//# sourceMappingURL=audio-component.style.js.map
